import { connect } from 'react-redux'
import CropComponent from "../components/CropComponent";
//import { updateAudioDuration } from "../actions/index"
import { cropImage, cropBG, toggleCrop, nextBtnClicked, toggleBgCrop, toggleFrame, toggleVideoCrop } from "../actions/index"

const mapStateToProps = (state, ownProps) => ({
  selectedScene   : state.localStore.get('selectedScene'),
  selectedItems   : state.localStore.get('selectedItems'),
  cropItem        : state.project.getIn(["scenes", state.localStore.get('selectedScene'), "workspaceItems",state.localStore.getIn(['selectedItems', 0])]),
  bgFilter        : state.project.getIn(["scenes", state.localStore.get('selectedScene'), "bgFilter"]),
  currentSceneItems  : state.project.getIn(['scenes',  state.localStore.get('selectedScene')]),
  videoItem : state.localStore.get('isVideoCropping')?state.project.getIn(["videos", state.localStore.get('cropVideoId')]):null,
  workspaceWidth  : state.project.get('width'),
  workspaceHeight : state.project.get('height'),
  workspaceBounds : state.localStore.get("workspaceBounds"),
  zoomFactor      : state.localStore.get('zoomFactor'),
  isCropping      : state.localStore.get('isCropping'),
  isFraming      : state.localStore.get('isFraming'),
  isBgCropping    : state.localStore.get('isBgCropping'),
  isVideoCropping    : state.localStore.get('isVideoCropping'),
  videoId    : state.localStore.get('cropVideoId'),
  projectType : state.project.get('width') > state.project.get('height') ? "hor" : state.project.get('width') < state.project.get('height') ? "ver" : "sqr"
})
       
const mapDispatchToProps = (dispatch, ownProps) => ({
  cropImage:(data, socket) => {
    dispatch(cropImage(data, socket))
  },
  cropBG:(data, socket) => {
    dispatch(cropBG(data, socket))
  },
  toggleCrop:(data) => {
    dispatch(toggleCrop(data))
  },
  toggleBgCrop:(data) => {
    dispatch(toggleBgCrop(data))
  },
  toggleFrame:(data) => {
    dispatch(toggleFrame(data))
  },
  toggleVideoCrop:(data) => {
    dispatch(toggleVideoCrop(data))
  },
  nextBtnClicked : (data) => {
    dispatch(nextBtnClicked(data))
  },
  updateTourArea : (data) => {
    dispatch(dispatch({type : "UPDATE_TOUR_AREA", data : {}}))
  }
})

const Crop = connect(
  mapStateToProps,
  mapDispatchToProps, 
  null, {withRef: true}
)(CropComponent)

export default Crop


// WEBPACK FOOTER //
// ./src/containers/Crop.js